import { Injectable } from "@angular/core";
import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpErrorResponse,
} from "@angular/common/http";
import { Observable } from "rxjs";
import { tap } from "rxjs/operators";
import { Location } from "@angular/common";
import { Router } from "@angular/router";
import { AnalyticsData } from "../analytics/analytics.model";
import { AnalyticsService } from "../analytics/analytics.service";
import { UserService } from "../user/user.service";

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  constructor(
    private router: Router,
    private location: Location,
    private userService: UserService,
    private analyticsService: AnalyticsService
  ) {}

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      tap(
        (event: HttpEvent<any>) => {},
        (err: any) => {
          if (err instanceof HttpErrorResponse) {
            if (err.status === 401) {
              console.log("401 error, redirecting to login");
              //this.userService.loginSso(request.url);
              // window.location.href = '/login?continue=/spectrum' + this.location.path();
            } else if (err.status === 403) {
              console.log("Access denied for url" + request.url);
              const data = new AnalyticsData();
              data.nonAuthorisedAccess = true;
              data.uri = request.url;
              this.analyticsService.pushData(data);
              this.router.navigate(["accessDenied"]);
            }
          }
        }
      )
    );
  }
}
